@if (release) {
  <div class="modal-header">
    <div class="flex-container align-items-center">
      <button type="button" class="btn-close me-2 d-inline-flex" data-bs-dismiss="modal" aria-label="Close"></button>
      <div class="d-inline-flex me-1">
        <i class="fa fa-fw fa-light fa-lg fa-file-lines text-muted"></i>
      </div>
      <span class="page-title">{{ isNewRelease ? 'New declaration' : (release.releaseData?.equipmentNumber || 'New declaration') }}</span>
    </div>
  </div>
  <div class="modal-body p-0">
    <app-tab-panel [sticky]="true" [alwaysRender]="true">
      <app-tab-item [templateRef]="details">
        <span class="tab-item">Details</span>
        <ng-template #details>
          <app-commercial-release-modal-details [release]="release" [editMode]="editMode"
                                                 (selectedConsignmentChange)="selectedConsignment = $event">
          </app-commercial-release-modal-details>
          <app-commercial-release-modal-parties [release]="release" [editMode]="editMode"
                                                [selectedConsignment]="selectedConsignment">
          </app-commercial-release-modal-parties>
        </ng-template>
      </app-tab-item>
      @if (release.releaseStatus?.status) {
        <app-tab-item [templateRef]="history">
          <span class="tab-item">History</span>
          <ng-template #history>
            <app-commercial-release-modal-history [id]="release.id"></app-commercial-release-modal-history>
          </ng-template>
        </app-tab-item>
      }
    </app-tab-panel>
  </div>
  <div class="modal-footer">
    <div class="d-flex flex-grow-1">
      <div class="container">
        <div class="row mx-4">
          @if (!isNewRelease && !release.releaseStatus?.cancelled &&
          (appContext.isCommercialReleaseDeclarant() || appContext.isCommercialReleaseEditor())) {
            <div class="col-auto">
              <app-confirmation-toggle>
                <button type="button" class="btn btn-outline-danger">Cancel release</button>
                <div class="modal-content">
                  <div class="modal-header"><h5 class="modal-title">Send cancel request to terminal</h5></div>
                  <div class="modal-body"><p>Are you sure that you want to cancel this release?</p></div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="cancelRelease()">
                      Cancel release
                    </button>
                  </div>
                </div>
              </app-confirmation-toggle>
            </div>
          }
          <div class="col-auto ms-auto">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">
              Close
            </button>
          </div>
          @if (!editMode && !isNewRelease && !release.releaseStatus?.cancelled && canEdit) {
            <div class="col-auto">
              <button type="button" class="btn btn-outline-secondary" (click)="startEditing()">Edit</button>
            </div>
          }
          @if (editMode && !release.releaseStatus?.cancelled && canEdit) {
            <div class="col-auto">
              <button type="button" class="btn btn-primary" (click)="sendDeclaration()">Save and send</button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
